import React, { useEffect } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { object, string } from 'yup';
import { Button, SvgIcon } from "@mui/material";
import { Check as CheckIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { TextInput, SelectInput } from '../../../../Helpers/Inputs';
import { setBasicInfo } from '../../../../../sessionStorage';
import States from '../../../../Helpers/Lists/States';
import '../Appointment.scss';

export default function Information(props) {

    const formMethods = useForm({
        resolver: yupResolver(Information.ValidationSchema),
        mode: 'all',
        reValidateMode: 'all',
        defaultValues: props.formState
    });

    const { handleSubmit, setValue } = formMethods;

    // manually call setValue for fields that don't play nice with react-hook-form register
    const handleValueChange = (field, value) => {
        props.onFieldChange(field, value);
    };

    useEffect(() => {
        let email = props.formState.email, firstName = props.formState.firstName, lastName = props.formState.lastName;
        if (props.basicInfo && props.basicInfo.firstName !== '') {
            firstName = props.basicInfo.firstName;
        }
        if (props.basicInfo && props.basicInfo.lastName !== '') {
            lastName = props.basicInfo.lastName;
        }
        if (props.basicInfo && props.basicInfo.email !== '') {
            email = props.basicInfo.email;
        }
        setValue('firstName', firstName);
        setValue('lastName', lastName);
        setValue('email', email);
        props.setMultiField(firstName, lastName, email);
    }, [])


    useEffect(() => {
        // Save data into basic info when updated

        if (props.basicInfo.firstName !== props.formState.firstName) {
            props.basicInfo.firstName = props.formState.firstName;
        }

        if (props.basicInfo.lastName !== props.formState.lastName) {
            props.basicInfo.lastName = props.formState.lastName;
        }

        if (props.basicInfo.email !== props.formState.email) {
            props.basicInfo.email = props.formState.email;
        }

        setBasicInfo(props.basicInfo);

    }, [props.formState.firstName, props.formState.lastName, props.formState.email]);

    return (
        <Col xs={12} md={6} lg={4}>
            <Row className="justify-content-center text-center mt-2 hide-class">
                <SvgIcon component={CheckIcon} className="icons" color="primary" fontSize="large" />
            </Row>
            <Row className="justify-content-center pt-2 pb-1">
                <h4>Let's start the application</h4>
            </Row>
            <Row className="mt-0 justify-content-center">
                <h6 className='hide-class'>We need some basic information.</h6>
                <h6 className='display-class'>First things first.</h6>
            </Row>
            <FormProvider {...formMethods}>
                <Form onSubmit={handleSubmit(props.onNext)} className='mt-3'>
                    <div className='mb-3'>
                        <TextInput
                            name="firstName"
                            id="firstName"
                            label="First Name"
                            value={props.formState.firstName}
                            onChange={(e) => handleValueChange('firstName', e.target.value)}
                        />
                    </div>

                    <div className='mb-3'>
                        <TextInput
                            name="lastName"
                            id="lastName"
                            label="Last Name"
                            value={props.formState.lastName}
                            onChange={(e) => handleValueChange('lastName', e.target.value)}
                        />
                    </div>

                    {props.showStateDropdown &&
                        <div className='mb-3'>
                            <SelectInput
                                name="state"
                                id="state"
                                value={props.formState.state}
                                onChange={(e) => handleValueChange('state', e.target.value)}
                                label="State"
                                selectOptions={States()}
                            />
                        </div>
                    }

                    <div className='mb-3'>
                        <TextInput
                            name="email"
                            id="email"
                            label="Email"
                            value={props.formState.email}
                            onChange={(e) => handleValueChange('email', e.target.value)}
                        />
                    </div>
                    <Row className="mt-4">
                        <Col className="text-start pb-3 btn-back">
                            <Button variant="outlined" className='w-100' size="medium" color="primary" onClick={props.onBack}>
                                BACK
                            </Button>
                        </Col>
                        <Col className="text-end pb-3">
                            <Button variant="contained" className='w-100' size="medium" color="primary" type="submit">
                                NEXT
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </FormProvider>
        </Col>
    )
}

Information.ValidationSchema = object().shape({
    firstName: string().required('First Name is required.').matches(/^[a-zA-Z]+$/, 'Invalid First Name'),
    lastName: string().required('Last Name is required.').matches(/^[a-zA-Z]+$/, 'Invalid Last Name'),
    email: string()
        .email('Email Address must be valid.')
        .required('Email Address is required.'),
});

Information.DefaultFormState = (prefill = false, basicInfo = null) => {
    return null
};

Information.propTypes = {
    formState: PropTypes.object.isRequired,
    quoter: PropTypes.object.isRequired,
    basicInfo: PropTypes.object.isRequired,
    onNext: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    isAppointmentSchedulingEnabled: PropTypes.bool.isRequired
};
